import { styled, Theme } from '@mui/material/styles'

export const contentErrorCodeSx = (theme: Theme) => ({ fontSize: 58, fontWeight: 500, color: '#736A8C' })

export const contentHeaderSx = (theme: Theme) => ({
	fontSize: 22,
	fontWeight: 600,
	color: theme.palette.text.darkBlue,
	marginBottom: theme.spacing(2),
	lineHeight: '31px',
})

export const contentMessageSx = (theme: Theme) => ({
	fontWeight: 400,
	fontSize: 14,
	lineHeight: '22px',
	color: '#000000',
	marginBottom: theme.spacing(5),
})

export const backButtonSx = (theme: Theme) => ({
	color: 'white',
	width: 165,
	height: 48,
	borderRadius: '8px',
	backgroundColor: theme.palette.text.darkBlue,
	fontSize: '14px',
})

export const ButtonLabel = styled('span')({
	fontSize: '14px',
	margin: 'auto',
})
